import { COMMON_COMPONENTS, PAGE_NAME } from '../AEM/constants';
import { getPKCEChallenge, getPKCEVerifier } from '../helpers/cryptoHelper';
import {
  API_STATUS_TYPES,
  LOADER_SCREEN_ACTION,
  PKCE_REDUCER_ACTION,
} from './constants';
import {
  IAEMCommonContent,
  IAEMScreenContent,
  IAPIStatus,
  IPKCEStatus,
} from './interface';

interface IAEMCommonContentAction {
  type: string;
  result: IAEMCommonContent;
}

interface IAEMScreenContentAction {
  type: string;
  result: IAEMScreenContent;
}

interface IAPIStatusAction {
  type: string;
  name: string;
}

interface IPKCEAction {
  type: string;
  name?: string;
}

export const commonAEMContentReducer = (
  AEMCommonContent: IAEMCommonContent,
  action: IAEMCommonContentAction,
) => {
  switch (action.type) {
    case COMMON_COMPONENTS.HEADER:
      return {
        ...AEMCommonContent,
        [action.type]: action.result[action.type],
      };
    case COMMON_COMPONENTS.CANCEL_MODAL_CONTENT:
      return {
        ...AEMCommonContent,
        [action.type]: action.result[action.type],
      };
    case COMMON_COMPONENTS.CONVERSION_MODAL:
      return {
        ...AEMCommonContent,
        [action.type]: action.result[action.type],
      };
    case COMMON_COMPONENTS.FOOTER:
      return {
        ...AEMCommonContent,
        [action.type]: action.result[action.type],
      };
    case COMMON_COMPONENTS.ACTIVE_MEMBER_FOOTER:
      return {
        ...AEMCommonContent,
        [action.type]: action.result[action.type],
      };
    case COMMON_COMPONENTS.GUEST_GOVERNMENT_FOOTER:
      return {
        ...AEMCommonContent,
        [action.type]: action.result[action.type],
      };
    case COMMON_COMPONENTS.ACTIVE_GOVERNMENT_FOOTER:
      return {
        ...AEMCommonContent,
        [action.type]: action.result[action.type],
      };
    case COMMON_COMPONENTS.CANCEL:
      return {
        ...AEMCommonContent,
        [action.type]: action.result[action.type],
      };
    case COMMON_COMPONENTS.SESSION_TIMEOUT:
      return {
        ...AEMCommonContent,
        [action.type]: action.result[action.type],
      };

    case COMMON_COMPONENTS.NAVIGATION_BAR:
      return {
        ...AEMCommonContent,
        [action.type]: action.result[action.type],
      };
    case COMMON_COMPONENTS.LOADER_MESSAGE:
      return {
        ...AEMCommonContent,
        [action.type]: action.result[action.type],
      };
    case COMMON_COMPONENTS.OLD_CONVERSION_MODAL:
      return {
        ...AEMCommonContent,
        [action.type]: action.result[action.type],
      };
    case COMMON_COMPONENTS.AUTOPAY_ENROLMENT_MODAL:
      return {
        ...AEMCommonContent,
        [action.type]: action.result[action.type],
      };
    case COMMON_COMPONENTS.HOURS_OF_OPERATION:
      return {
        ...AEMCommonContent,
        [action.type]: action.result[action.type],
      };
    case COMMON_COMPONENTS.AUTOPAY_SETUP_MODAL_CONTENT:
      return {
        ...AEMCommonContent,
        [action.type]: action.result[action.type],
      };
    case COMMON_COMPONENTS.GUEST_AUTOPAY_SETUP_MODAL_CONTENT:
      return {
        ...AEMCommonContent,
        [action.type]: action.result[action.type],
      };
    case COMMON_COMPONENTS.BROKER_AUTOPAY_SETUP_MODAL_CONTENT:
      return {
        ...AEMCommonContent,
        [action.type]: action.result[action.type],
      };
    case COMMON_COMPONENTS.ECONSENT_MODAL_CONTENT: {
      return {
        ...AEMCommonContent,
        [action.type]: action.result[action.type],
      };
    }
    default:
      return AEMCommonContent;
  }
};

export const screenAEMContentReducer = (
  AEMScreenContent: IAEMScreenContent,
  action: IAEMScreenContentAction,
) => {
  switch (action.type) {
    case PAGE_NAME.MEMBER_VALIDATION:
      return {
        ...AEMScreenContent,
        [action.type]: action.result[action.type],
      };
    case PAGE_NAME.PAYMENT_TERMS:
      return {
        ...AEMScreenContent,
        [action.type]: action.result[action.type],
      };
    case PAGE_NAME.ALL_PAYMENT_DETAILS:
      return {
        ...AEMScreenContent,
        [action.type]: action.result[action.type],
      };
    case PAGE_NAME.ALL_PAYMENT_DETAILS_ACTIVE:
      return {
        ...AEMScreenContent,
        [action.type]: action.result[action.type],
      };
    case PAGE_NAME.PAYMENT_DETAILS:
      return {
        ...AEMScreenContent,
        [action.type]: action.result[action.type],
      };
    case PAGE_NAME.PREMIUM_PAYMENTS:
      return {
        ...AEMScreenContent,
        [action.type]: action.result[action.type],
      };
    case PAGE_NAME.MEDICARE_LANDING:
      return {
        ...AEMScreenContent,
        [action.type]: action.result[action.type],
      };
    case PAGE_NAME.SELECT_PLAN:
      return {
        ...AEMScreenContent,
        [action.type]: action.result[action.type],
      };
    case PAGE_NAME.PAYMENT_DETAILS_ACTIVE_MEMBER:
      return {
        ...AEMScreenContent,
        [action.type]: action.result[action.type],
      };
    case PAGE_NAME.PAYMENT_COMPLETED:
      return {
        ...AEMScreenContent,
        [action.type]: action.result[action.type],
      };
    case PAGE_NAME.CANCELLED_PAYMENT_CONFIRMATION:
      return {
        ...AEMScreenContent,
        [action.type]: action.result[action.type],
      };
    case PAGE_NAME.CANCELLED_CONFIRMATION_INTERSTITIAL:
      return {
        ...AEMScreenContent,
        [action.type]: action.result[action.type],
      };
    case PAGE_NAME.UPDATE_PAYMENT_COMPLETED:
      return {
        ...AEMScreenContent,
        [action.type]: action.result[action.type],
      };
    case PAGE_NAME.REVIEW_PAYMENT_DETAILS:
      return {
        ...AEMScreenContent,
        [action.type]: action.result[action.type],
      };
    case PAGE_NAME.REVIEW_PAYMENT_DETAILS_ACTIVE_MEMBER:
      return {
        ...AEMScreenContent,
        [action.type]: action.result[action.type],
      };
    case PAGE_NAME.MAKE_PAYMENT:
      return {
        ...AEMScreenContent,
        [action.type]: action.result[action.type],
      };
    case PAGE_NAME.BROWSER_INCOMPATIBLE_ERROR:
      return {
        ...AEMScreenContent,
        [action.type]: action.result[action.type],
      };
    case PAGE_NAME.UNABLE_TO_PROCESS_PAYMENT:
      return {
        ...AEMScreenContent,
        [action.type]: action.result[action.type],
      };
    case PAGE_NAME.MAKE_PAYMENT_ACTIVE_MEMBER:
      return {
        ...AEMScreenContent,
        [action.type]: action.result[action.type],
      };
    case PAGE_NAME.MY_WALLET:
      return {
        ...AEMScreenContent,
        [action.type]: action.result[action.type],
      };
    case PAGE_NAME.ADD_NEW_PAYMENT_METHOD_WALLET_BANK:
      return {
        ...AEMScreenContent,
        [action.type]: action.result[action.type],
      };
    case PAGE_NAME.ADD_NEW_PAYMENT_METHOD_WALLET_CARD:
      return {
        ...AEMScreenContent,
        [action.type]: action.result[action.type],
      };
    case PAGE_NAME.UPDATE_WALLET_BANK:
      return {
        ...AEMScreenContent,
        [action.type]: action.result[action.type],
      };
    case PAGE_NAME.UPDATE_WALLET_CARD:
      return {
        ...AEMScreenContent,
        [action.type]: action.result[action.type],
      };
    case PAGE_NAME.VIEW_SCHEDULED_PAYMENTS:
      return {
        ...AEMScreenContent,
        [action.type]: action.result[action.type],
      };
    case PAGE_NAME.BINDER_VIEW_SCHEDULED_PAYMENTS:
      return {
        ...AEMScreenContent,
        [action.type]: action.result[action.type],
      };
    case PAGE_NAME.TECHNICAL_DIFFICULTY:
      return {
        ...AEMScreenContent,
        [action.type]: action.result[action.type],
      };
    case PAGE_NAME.SCHEDULED_PAYMENT_CONFIRMATION:
      return {
        ...AEMScreenContent,
        [action.type]: action.result[action.type],
      };
    case PAGE_NAME.AUTO_PAYMENT_SETTINGS:
      return {
        ...AEMScreenContent,
        [action.type]: action.result[action.type],
      };
    case PAGE_NAME.AUTO_PAYMENT_SUCCESS:
      return {
        ...AEMScreenContent,
        [action.type]: action.result[action.type],
      };
    case PAGE_NAME.PAYMENT_HISTORY:
      return {
        ...AEMScreenContent,
        [action.type]: action.result[action.type],
      };
    case PAGE_NAME.HS_PAYMENT_HISTORY:
      return {
        ...AEMScreenContent,
        [action.type]: action.result[action.type],
      };
    case PAGE_NAME.BILLING_HISTORY_LIST:
      return {
        ...AEMScreenContent,
        [action.type]: action.result[action.type],
      };
    case PAGE_NAME.BILLING_HISTORY_SPREADSHEET:
      return {
        ...AEMScreenContent,
        [action.type]: action.result[action.type],
      };
    case PAGE_NAME.BINDER_MAKE_PAYMENT:
      return {
        ...AEMScreenContent,
        [action.type]: action.result[action.type],
      };
    case PAGE_NAME.BINDER_PAY_LATER_MAKE_PAYMENT:
      return {
        ...AEMScreenContent,
        [action.type]: action.result[action.type],
      };
    case PAGE_NAME.REVIEW_BINDER_PAYMENT_DETAILS:
      return {
        ...AEMScreenContent,
        [action.type]: action.result[action.type],
      };
    case PAGE_NAME.APPLICANT_BINDER_PAYMENT_DETAILS:
      return {
        ...AEMScreenContent,
        [action.type]: action.result[action.type],
      };
    case PAGE_NAME.BINDER_PAY_NOW_CONFIRMATION_PAYMENT_DETAILS:
      return {
        ...AEMScreenContent,
        [action.type]: action.result[action.type],
      };
    case PAGE_NAME.BINDER_PAY_LATER_CONFIRMATION_PAYMENT_DETAILS:
      return {
        ...AEMScreenContent,
        [action.type]: action.result[action.type],
      };
    case PAGE_NAME.BINDER_PAY_LATER_SCHEDULE_CONFIRMATION_PAYMENT_DETAILS:
      return {
        ...AEMScreenContent,
        [action.type]: action.result[action.type],
      };
    case PAGE_NAME.BINDER_PAY_LATER_CANCEL_CONFIRMATION_PAYMENT_DETAILS:
      return {
        ...AEMScreenContent,
        [action.type]: action.result[action.type],
      };
    case PAGE_NAME.BINDER_PAY_LATER_UPDATE_CONFIRMATION_PAYMENT_DETAILS:
      return {
        ...AEMScreenContent,
        [action.type]: action.result[action.type],
      };
    case PAGE_NAME.BINDER_ALL_PAYMENTS_PAGE:
      return {
        ...AEMScreenContent,
        [action.type]: action.result[action.type],
      };
    case PAGE_NAME.BINDER_PAYMENTS_PAGE:
      return {
        ...AEMScreenContent,
        [action.type]: action.result[action.type],
      };
    case PAGE_NAME.VIEW_PAYMENT_TRACKER_DETAILS_SCREEN:
      return {
        ...AEMScreenContent,
        [action.type]: action.result[action.type],
      };
    case PAGE_NAME.PICK_YOUR_PLAN_VIEW:
      return {
        ...AEMScreenContent,
        [action.type]: action.result[action.type],
      };
    case PAGE_NAME.TERMS_OF_USE:
      return {
        ...AEMScreenContent,
        [action.type]: action.result[action.type],
      };
    case PAGE_NAME.NO_ACCESS:
      return {
        ...AEMScreenContent,
        [action.type]: action.result[action.type],
      };
    case PAGE_NAME.LOGGED_OUT:
      return {
        ...AEMScreenContent,
        [action.type]: action.result[action.type],
      };
    case PAGE_NAME.SESSION_TIMEOUT:
      return {
        ...AEMScreenContent,
        [action.type]: action.result[action.type],
      };
    case PAGE_NAME.AUTO_PAY_PREMIUM_PAYMENT:
      return {
        ...AEMScreenContent,
        [action.type]: action.result[action.type],
      };
    case PAGE_NAME.AUTOMATIC_PAYMENTS_SETUP:
    case PAGE_NAME.MAPD_PAYMENTS:
      return {
        ...AEMScreenContent,
        [action.type]: action.result[action.type],
      };
    default:
      return AEMScreenContent;
  }
};

export const apiStatusReducer = (
  APIStatus: IAPIStatus,
  action: IAPIStatusAction,
) => {
  switch (action.name) {
    case API_STATUS_TYPES.SHOW_ERROR_SCREEN:
      return { ...APIStatus, [API_STATUS_TYPES.SHOW_ERROR_SCREEN]: true };

    case API_STATUS_TYPES.RESET_SHOW_ERROR_SCREEN:
      return { ...APIStatus, [API_STATUS_TYPES.SHOW_ERROR_SCREEN]: false };

    case API_STATUS_TYPES.LOADER_SCREEN_COUNTER:
      switch (action.type) {
        case LOADER_SCREEN_ACTION.INCREMENT:
          return {
            ...APIStatus,
            [API_STATUS_TYPES.LOADER_SCREEN_COUNTER]:
              APIStatus.loaderScreenCounter + 1,
          };
        case LOADER_SCREEN_ACTION.DECREMENT:
          return {
            ...APIStatus,
            [API_STATUS_TYPES.LOADER_SCREEN_COUNTER]:
              APIStatus.loaderScreenCounter - 1,
          };
        default:
          return APIStatus;
      }
    default:
      return APIStatus;
  }
};

export const pkceReducerInit = (): IPKCEStatus => {
  const verifier = getPKCEVerifier();
  return {
    verifier: verifier,
    challenge: getPKCEChallenge(verifier),
  };
};

export const pkceReducer = (
  state: IPKCEStatus,
  action: IPKCEAction,
): IPKCEStatus => {
  switch (action.type) {
    case PKCE_REDUCER_ACTION.INITIALIZE:
    case PKCE_REDUCER_ACTION.REFRESH:
      return pkceReducerInit();
    default:
      throw Error(
        `Unhandled action with type: ${action.type} // state: ${state}`,
      );
  }
};
